import { Box } from "@mui/material";
import React, {  } from "react";
import { useStore } from "utils/useStore";
import { FieldUse } from "models/Reporting/ReportField";
import SideNavigationLink from "Layouts/SideNavigationNew/SideNavigationLink";
import AddIcon from "@mui/icons-material/Add";
import SignalsPageStore from "../Store/SignalsPageStore";
import ReportsStore from "../Reports/Stores/ReportsStore";
import { ReportEditorStore } from "../Reports/Stores/ReportEditorStore";

// Create New Reports for when on Reporting view
export const NewReportButton = () => {
    const signalsPageStore = useStore(SignalsPageStore);
    const reportsStore = useStore(ReportsStore);
    const reportEditorStore = useStore(ReportEditorStore);

    function onCreateNewReport() {
        reportsStore.initializeReportEditorForNew();
        reportEditorStore?.currentReport?.reportFields
            .filter(
                (value) =>
                    value.fieldUse !== undefined &&
                    [FieldUse.X, FieldUse.Y].includes(value.fieldUse),
            )
            .forEach((value) => {
                reportEditorStore.currentReport?.removeReportField(value);
            });
        reportsStore.reportDataViewModel.googleFormattedData = [];
    }

    return (
        <SideNavigationLink
            val={{
                title: (
                    <Box
                        id="signals-create-new-dashboard"
                        fontSize="14px"
                        onClick={onCreateNewReport}
                    >
                        New Report
                    </Box>
                ),
                icon: <AddIcon />,
                link: `/focus/signals/reporteditor/${signalsPageStore.authStore.orgStore.selectedOrganization?.id}/`,
                signalsVariant: true,
            }}
            replaceLinks={{}}
        />
    );
};
